import React, { useState } from "react";
import "./CollegeLabsPanel.css";
import "./LabDetailsPanel.css";
import EnquiryForm from "../EnquiryForm";
import {
  FaTimes, FaLayerGroup, FaArrowRight,
  FaLightbulb, FaPaperPlane, FaLeaf, FaFlask,
} from "react-icons/fa";

/* ══════════════════════════════════════════
   BUDGET ICONS
══════════════════════════════════════════ */
const BUDGET_ICONS = {
  "lab setup": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="11" width="16" height="7" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <rect x="5" y="7" width="10" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
      <rect x="8" y="3" width="4" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
      <line x1="10" y1="2" x2="10" y2="3" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  "infrastructure": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="11" width="16" height="7" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <rect x="5" y="7" width="10" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
      <rect x="8" y="3" width="4" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
    </svg>
  ),
  "equipment": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="3.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.22 4.22l1.42 1.42M14.36 14.36l1.42 1.42M4.22 15.78l1.42-1.42M14.36 5.64l1.42-1.42" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  "kits": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="6" width="14" height="11" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
      <path d="M7 6V5a3 3 0 0 1 6 0v1" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="10" y1="10" x2="10" y2="13" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="8.5" y1="11.5" x2="11.5" y2="11.5" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  "curriculum": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="14" height="14" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
      <line x1="6" y1="7" x2="14" y2="7" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="6" y1="10" x2="14" y2="10" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="6" y1="13" x2="10" y2="13" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  "training": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="7" r="3" stroke="#0e2a5a" strokeWidth="1.5"/>
      <path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  "software": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="4" width="16" height="11" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
      <line x1="7" y1="18" x2="13" y2="18" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="10" y1="15" x2="10" y2="18" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M6 8.5l2.5 2L6 12.5" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="10.5" y1="12.5" x2="14" y2="12.5" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  "maintenance": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 3.5a3 3 0 0 1 0 4.24l-8 8a3 3 0 1 1-4.24-4.24l8-8A3 3 0 0 1 14.5 3.5z" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="4.5" cy="15.5" r="1" fill="#0e2a5a"/>
    </svg>
  ),
  "installation": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 3.5a3 3 0 0 1 0 4.24l-8 8a3 3 0 1 1-4.24-4.24l8-8A3 3 0 0 1 14.5 3.5z" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="4.5" cy="15.5" r="1" fill="#0e2a5a"/>
    </svg>
  ),
  "prototyping": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="6" height="6" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <rect x="11" y="3" width="6" height="6" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <rect x="3" y="11" width="6" height="6" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <rect x="11" y="11" width="6" height="6" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
    </svg>
  ),
  "innovation": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2a6 6 0 0 1 4 10.47V14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1.53A6 6 0 0 1 10 2z" stroke="#0e2a5a" strokeWidth="1.5"/>
      <line x1="7.5" y1="17" x2="12.5" y2="17" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  "cloud": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 14a4 4 0 0 1-.5-7.95A5 5 0 0 1 15 8.5a3 3 0 0 1-.5 5.5H5z" stroke="#0e2a5a" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  ),
  "engineer": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="7" r="3" stroke="#0e2a5a" strokeWidth="1.5"/>
      <path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M14 3l1.5 1.5M16 6h-1.5" stroke="#0e2a5a" strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
  "research": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <line x1="13" y1="13" x2="17" y2="17" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  "uav": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="2.5" stroke="#0e2a5a" strokeWidth="1.5"/>
      <circle cx="4"  cy="4"  r="1.5" stroke="#0e2a5a" strokeWidth="1.3"/>
      <circle cx="16" cy="4"  r="1.5" stroke="#0e2a5a" strokeWidth="1.3"/>
      <circle cx="4"  cy="16" r="1.5" stroke="#0e2a5a" strokeWidth="1.3"/>
      <circle cx="16" cy="16" r="1.5" stroke="#0e2a5a" strokeWidth="1.3"/>
      <line x1="5.5" y1="5.5" x2="8"  y2="8"   stroke="#0e2a5a" strokeWidth="1.2"/>
      <line x1="14.5" y1="5.5" x2="12" y2="8"  stroke="#0e2a5a" strokeWidth="1.2"/>
      <line x1="5.5" y1="14.5" x2="8"  y2="12"  stroke="#0e2a5a" strokeWidth="1.2"/>
      <line x1="14.5" y1="14.5" x2="12" y2="12" stroke="#0e2a5a" strokeWidth="1.2"/>
    </svg>
  ),
  "simulation": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="4" width="16" height="11" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
      <polyline points="5,12 8,8 11,10 14,6" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  ),
  "default": (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="14" height="14" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
    </svg>
  ),
};

function getBudgetIcon(label) {
  const l = label.toLowerCase();
  if (l.includes("uav") || l.includes("flight") || l.includes("drone")) return BUDGET_ICONS["uav"];
  if (l.includes("simulation"))          return BUDGET_ICONS["simulation"];
  if (l.includes("cloud") || l.includes("connectivity") || l.includes("monitoring")) return BUDGET_ICONS["cloud"];
  if (l.includes("installation"))        return BUDGET_ICONS["installation"];
  if (l.includes("maintenance"))         return BUDGET_ICONS["maintenance"];
  if (l.includes("prototyping") || l.includes("fabrication") || l.includes("automation")) return BUDGET_ICONS["prototyping"];
  if (l.includes("research") || l.includes("incubation")) return BUDGET_ICONS["research"];
  if (l.includes("innovation engineer") || l.includes("engineer support")) return BUDGET_ICONS["engineer"];
  if (l.includes("innovation"))          return BUDGET_ICONS["innovation"];
  if (l.includes("software"))            return BUDGET_ICONS["software"];
  if (l.includes("curriculum"))          return BUDGET_ICONS["curriculum"];
  if (l.includes("training"))            return BUDGET_ICONS["training"];
  if (l.includes("kits") || l.includes("equipment") || l.includes("ecosystem")) return BUDGET_ICONS["kits"];
  if (l.includes("lab setup") || l.includes("smart lab") || l.includes("smart learning") || l.includes("smart automation")) return BUDGET_ICONS["lab setup"];
  if (l.includes("infrastructure"))      return BUDGET_ICONS["infrastructure"];
  return BUDGET_ICONS["default"];
}

/* ══════════════════════════════════════════
   LAB DATA
══════════════════════════════════════════ */
const labs = [
  {
    name: "Innovation Lab",
    icon: <FaLightbulb />,
    img: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=600&q=80",
    image: "/assets/images/innovation10.png",
    domains: ["Electronics", "Embedded System", "Robotics & AI"],
    packages: [
      {
        label: "Starter", price: "₹7L", subtitle: "BASIC SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab Setup", desc: "Prototyping Tools · Idea Incubation · Design Thinking Zone" },
          { icon: "📚", title: "Training & Curriculum", desc: "Electronics · Embedded Systems · Robotics Basics · AI Intro" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Exposure" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "Inter-College Hackathons · Project Expos · R&D Challenges" },
          { icon: "🎓", title: "College Benefits", desc: "Innovation Culture · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Innovation Lab Setup & Smart Lab Integration", percent: 30, color: "blue" },
          { label: "Electronics, Embedded Systems, Robotics & AI Kits", percent: 25, color: "blue" },
          { label: "Prototyping Tools & Project Development Components", percent: 15, color: "blue" },
          { label: "Innovation Engineer Support", percent: 15, color: "blue" },
          { label: "Design Thinking & Student Innovation Programs", percent: 10, color: "blue" },
          { label: "Installation & Maintenance Support", percent: 10, color: "blue" },
        ],
        total: "₹7 Lakhs",
      },
      {
        label: "Intermediate", price: "₹10L", subtitle: "ADVANCED SETUP",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab Setup", desc: "Prototyping Tools · Idea Incubation · Cross-disciplinary Zones" },
          { icon: "📚", title: "Training & Curriculum", desc: "Electronics · Embedded Systems · Robotics · AI & ML Basics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Workshops · Mentor Sessions · Industry Connect" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "Hackathons · Expos · Research Grants · Patent Guidance" },
          { icon: "🎓", title: "College Benefits", desc: "NBA/NAAC Boost · Student Projects · Patent & Research Exposure" },
        ],
        budget: [
          { label: "Advanced Innovation Lab Setup & Smart Lab Integration", percent: 30, color: "blue" },
          { label: "Advanced Electronics, Embedded Systems, Robotics & Al Kits", percent: 25, color: "blue" },
          { label: "Rapid Prototyping, Testing & Fabrication Tools", percent: 15, color: "blue" },
          { label: "Rapid Prototyping, Testing & Fabrication Tools", percent: 15, color: "green" },
          { label: "Idea Incubation, Design Thinking & Student Project Labs", percent: 10, color: "blue" },
          { label: "Installation, Technical Support & Maintenances", percent: 5, color: "blue" },
        ],
        total: "₹10 Lakhs",
      },
      {
        label: "Advanced", price: "₹15L", subtitle: "FULL SUITE",
        delivers: [
          { icon: "🏛️", title: "Innovation Lab Setup", desc: "Full Prototyping Suite · Incubation Hub · Industry-grade Zones" },
          { icon: "📚", title: "Training & Curriculum", desc: "Advanced Electronics · Embedded · Robotics · AI/ML · IoT" },
          { icon: "🎤", title: "Expert Engagement", desc: "Resident Mentor · Bi-annual Workshops · Industry Immersion" },
          { icon: "🏆", title: "Innovation & Competitions", desc: "National Hackathons · Research Papers · Startup Incubation" },
          { icon: "🎓", title: "College Benefits", desc: "NBA/NAAC Score Boost · Patents · Research Publications" },
        ],
        budget: [
          { label: "Enterprise Innovation Lab Setup & Smart Learning Environment", percent: 30, color: "blue" },
          { label: "Advanced Electronics, Embedded Systems, Robotics & AI Ecosystem", percent: 25, color: "blue" },
          { label: "Prototyping, Automation & Product Development Systems", percent: 15, color: "green" },
          { label: "Innovation Engineer Support & Advanced Training Programs", percent: 15, color: "green" },
          { label: "Research, Incubation & Cross-Disciplinary Innovation Activities", percent: 15, color: "blue" },
          { label: "Installation, Commissioning & Technical Support", percent: 5, color: "blue" },
        ],
        total: "₹15 Lakhs",
      },
    ],
  },
  {
    name: "Drone Lab",
    icon: <FaPaperPlane />,
    img: "https://images.unsplash.com/photo-1508614589041-895b88991e3e?w=600&q=80",
    image: "https://images.unsplash.com/photo-1508614589041-895b88991e3e?w=600&q=80",
    domains: ["UAV Systems", "Navigation", "Electronics", "Aerial Tech"],
    highlights: [
      { icon: "🚁", label: "UAV Assembly Kits", desc: "Hands-on build & fly training with modular drone frames" },
      { icon: "🖥️", label: "Flight Simulation", desc: "Real-world flight scenarios in a safe virtual environment" },
      { icon: "🛰️", label: "Navigation Systems", desc: "GPS, compass & barometer-based autonomous navigation" },
      { icon: "⚙️", label: "Pixhawk Integration", desc: "Industry-standard flight controller setup & programming" },
      { icon: "🔌", label: "Plug-and-Play Drones", desc: "Pre-configured UAVs ready for immediate flight training" },
      { icon: "🛠️", label: "Custom UAV Build Models", desc: "Design-to-fly custom drone projects for advanced learners" },
      { icon: "📡", label: "Aerial Data Processing", desc: "Capture, process & analyse aerial imagery & sensor data" },
    ],
    packages: [
      {
        label: "Standard", price: "₹15L+", subtitle: "COMPLETE SETUP",
        delivers: [
          { icon: "🚁", title: "Drone Lab Setup", desc: "UAV Assembly Kits · Flight Simulation · Navigation Systems" },
          { icon: "📚", title: "Training & Curriculum", desc: "UAV Systems · Navigation · Aerial Data Processing · Electronics" },
          { icon: "🎤", title: "Expert Engagement", desc: "Drone Workshops · Industry Mentors · Field Demonstrations" },
          { icon: "🏆", title: "Competitions & Projects", desc: "Drone Racing · Aerial Mapping · UAV Challenge Events" },
          { icon: "🎓", title: "College Benefits", desc: "Research Exposure · Student Projects · Industry Partnerships" },
        ],
        budget: [
          { label: "Lab Setup & Infrastructure", percent: 40, color: "blue" },
          { label: "UAV Kits & Flight Equipment", percent: 35, color: "blue" },
          { label: "Curriculum & Training Support", percent: 15, color: "green" },
          { label: "Simulation Software & Tools", percent: 5, color: "green" },
          { label: "Maintenance & Support", percent: 5, color: "blue" },
        ],
        total: "₹15L+",
      },
    ],
  },
  {
    name: "IoT,IIOT & AIOT Lab",
    icon: <FaLeaf />,
    img: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80",
    domains: ["IoT", "AI & ML", "Edge Computing", "Cloud Systems"],
    highlights: [
      { icon: "🤖", label: "Edge AI Devices", desc: "On-device inference with edge AI hardware" },
      { icon: "☁️", label: "Cloud IoT Networks", desc: "Cloud-connected sensor & data pipelines" },
      { icon: "🏭", label: "Industrial IoT Systems", desc: "Real-world IIoT deployments & protocols" },
      { icon: "🧠", label: "ML Modules", desc: "Machine learning training & deployment kits" },
      { icon: "⚡", label: "Smart Automation", desc: "Intelligent control & automation platforms" },
      { icon: "📊", label: "Real-time Monitoring", desc: "Live dashboards & sensor data visualisation" },
      { icon: "🔗", label: "Intelligent Systems", desc: "End-to-end smart system development" },
    ],
    packages: [
      {
        label: "Standard", price: "₹15L+", subtitle: "COMPLETE SETUP",
        delivers: [
          { icon: "🌐", title: "IoT & AI Lab Setup", desc: "Edge Devices · Cloud IoT Networks · ML Training Modules" },
          { icon: "📚", title: "Training & Curriculum", desc: "IoT Fundamentals · AI Basics · Edge Computing · Cloud Intro" },
          { icon: "🎤", title: "Expert Engagement", desc: "AI Workshops · IoT Bootcamps · Industry Expert Sessions" },
          { icon: "🏆", title: "Competitions & Projects", desc: "Smart Systems Projects · AI Hackathons · IoT Expo" },
          { icon: "🎓", title: "College Benefits", desc: "Research Projects · Student Innovation · Industry Collaborations" },
        ],
        budget: [
          { label: "IoT,IIOT & AIOT Lab Setup & Smart Automation Environment", percent: 30, color: "blue" },
          { label: "Respective Development Kits", percent: 25, color: "blue" },
          { label: "Cloud Connectivity, Data Monitoring & Automation Platforms", percent: 15, color: "blue" },
          { label: "Innovation Engineer Support & Industry Training Programs", percent: 15, color: "blue" },
          { label: "Installation, Integration & Technical Support", percent: 10, color: "blue" },
          { label: "Maintenance & Support", percent: 5, color: "blue" },
        ],
        total: "₹15L+",
      },
    ],
  },
  {
    name: "AICTE Idea Lab",
    icon: <FaFlask />,
    img: "https://images.unsplash.com/photo-1563770660941-20978e870e26?w=600&q=80",
    image: "/assets/images/aicteimage.png",
    domains: ["Tinkering", "Fabrication", "Electronics", "Innovation"],
  },
];

/* ══════════════════════════════════════════
   PACKAGE DETAIL VIEW
══════════════════════════════════════════ */
function PackageDetail({ lab, pkg, onBackToPkgs, onClose }) {
  const [showEnquiry, setShowEnquiry] = useState(false);

  return (
    <div className="panel-wrapper">
      <div className="panel-header">
        <button className="back-btn" onClick={onBackToPkgs}>← Back to All Labs</button>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      <div className="pkg-detail-body">
        <div className="pkg-detail-left">
          <div className="pkg-detail-section-label">
            <span className="pkg-detail-dot blue" />
            WHAT IT DELIVERS — {pkg.label.toUpperCase()}
          </div>
          <div className="pkg-detail-card">
            <div className="pkg-detail-card-header">
              <span className="pkg-label-badge">{pkg.label.toUpperCase()}</span>
              <div className="pkg-detail-card-title">
                <h3>{lab.name} — {pkg.label} Setup</h3>
                <p>Five Pillars of the College Innovation Program</p>
              </div>
              <button className="close-btn" onClick={onClose}>✕</button>
            </div>
            <div className="pkg-delivers-list">
              {pkg.delivers?.map((item, i) => (
                <div key={i} className="pkg-deliver-item">
                  <div className="pkg-deliver-icon">{item.icon}</div>
                  <div>
                    <strong>{item.title}</strong>
                    <p dangerouslySetInnerHTML={{ __html: item.desc }} />
                  </div>
                </div>
              ))}
            </div>
            <div className="pkg-detail-footer">
              <span className="footer-dot" />
              <span>End-to-end implementation & support by iBots</span>
              <button className="enquire-btn" onClick={() => setShowEnquiry(true)}>
  ENQUIRE NOW →
</button>
            </div>
          </div>
        </div>

        {/* RIGHT — budget breakdown with icons */}
        <div className="pkg-detail-right">
          <div className="pkg-detail-section-label">
            <span className="pkg-detail-dot blue" />
            {pkg.label.toUpperCase()} COST BREAKDOWN
          </div>
          <div className="pkg-budget-card">
            <div className="pkg-budget-header">
              <span className="blue-dot-sm" />
              <strong>BUDGET BREAKDOWN</strong>
            </div>
            {pkg.budget?.map((item, i) => (
              <div key={i} className="pkg-budget-item">
                <div className="pkg-budget-row">
                  <span className="pkg-budget-label">
                    <span className="pkg-budget-icon">
                      {getBudgetIcon(item.label)}
                    </span>
                    {item.label}
                  </span>
                  <span className="pkg-budget-percent">{item.percent}%</span>
                </div>
                <div className="pkg-bar-track">
                  <div
                    className={`pkg-bar ${item.color}`}
                    style={{ width: `${item.percent}%` }}
                  />
                </div>
              </div>
            ))}
            <div className="pkg-total-box">
              <span>Total Investment — {pkg.label}</span>
              <span className="pkg-total-price">{pkg.total}</span>
            </div>
          </div>
        </div>
      </div>

      {showEnquiry && (
        <EnquiryForm
  labName={lab.name}
  labImage={lab.image}
  packageLabel={pkg.label}
  packagePrice={pkg.price}
  onClose={() => setShowEnquiry(false)}
/>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════
   PACKAGE SELECT VIEW
══════════════════════════════════════════ */
function LabDetail({ lab, onBack, onClose }) {
  const [selectedPackage, setSelectedPackage] = useState(null);

  if (selectedPackage !== null) {
    return (
      <PackageDetail
        lab={lab}
        pkg={lab.packages[selectedPackage]}
        onBackToPkgs={() => setSelectedPackage(null)}
        onClose={onClose}
      />
    );
  }

  return (
    <div className="panel-wrapper">
      <div className="panel-header">
        <button className="back-btn" onClick={onBack}>← Back to All Labs</button>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      <div className="panel-center">
        <div className="panel-left-card">
          <img src={lab.image} alt={lab.name} />
          <div className="panel-lab-info">
            <div className="panel-lab-title">
              <span>{lab.name}</span>
              <span className="arrow-up">∧</span>
            </div>
            <p className="domain-title">
              <span className="domain-icon">≡</span> DOMAINS INCLUDES
            </p>
            <div className="tags">
              {lab.domains?.map((d, i) => (
                <span key={i} className="tag">● {d}</span>
              ))}
            </div>
            <button className="view-btn">
              <span className="view-btn-left">
                <span className="view-btn-icon">≡</span> VIEW PACKAGES
              </span>
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>

        <div className="panel-right">
          <div className="choose-row">
            <span className="choose-badge">🏷 CHOOSE YOUR PACKAGE</span>
            <span className="choose-hint">Select a plan to see what's included</span>
          </div>

          {lab.packages?.length === 1 ? (
            <div style={{ display: "flex", gap: "14px", flex: 1 }}>
              <div
                className="package-card"
                style={{ flex: 1 }}
                onClick={() => setSelectedPackage(0)}
              >
                <div className="pkg-top">
                  <h4>{lab.packages[0].label}</h4>
                  <span className="pkg-arrow-circle">→</span>
                </div>
                <h2>{lab.packages[0].price}</h2>
                <span className="pkg-subtitle">{lab.packages[0].subtitle}</span>
                <div className="pkg-divider" />
                {lab.highlights && (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "10px" }}>
                    {lab.highlights.map((h, i) => (
                      <span key={i} style={{
                        display: "inline-flex", alignItems: "center", gap: "5px",
                        background: "#eef1f8", borderRadius: "20px",
                        padding: "4px 10px",
                        fontSize: "10px", fontWeight: 700, color: "#0e2a5a",
                        border: "1.5px solid #dde4f0",
                        whiteSpace: "nowrap",
                      }}>
                        <span style={{ fontSize: "11px" }}>{h.icon}</span>
                        {h.label}
                      </span>
                    ))}
                  </div>
                )}
                <div className="pkg-card-footer" style={{ marginTop: "auto" }}>
                  <span className="pkg-card-dot" />
                  Click to view details
                </div>
              </div>
            </div>
          ) : (
            <div className="package-grid">
              {lab.packages?.map((p, i) => (
                <div
                  key={i}
                  className="package-card"
                  onClick={() => setSelectedPackage(i)}
                >
                  <div className="pkg-top">
                    <h4>{p.label}</h4>
                    <span className="pkg-arrow-circle">→</span>
                  </div>
                  <h2>{p.price}</h2>
                  <span className="pkg-subtitle">{p.subtitle}</span>
                  <div className="pkg-divider" />
                  <div className="pkg-card-footer">
                    <span className="pkg-card-dot" />
                    Click to view details
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   MAIN EXPORT
══════════════════════════════════════════ */
export default function CollegeLabsPanel({ onClose }) {
  const [selectedLab, setSelectedLab] = useState(null);
  const [enquiryLab, setEnquiryLab] = useState(null);

  const handleCardClick = (lab, i) => {
  if (lab.name === "AICTE Idea Lab") {
    setEnquiryLab(lab);
  } else {
      setSelectedLab(i);
    }
  };

  if (selectedLab !== null) {
    return (
      <LabDetail
        lab={labs[selectedLab]}
        onBack={() => setSelectedLab(null)}
        onClose={onClose}
      />
    );
  }

  return (
    <div className="clp-panel">
      <div className="clp-header">
        <div className="clp-title">
          <span className="clp-dot" />
          <h3>College Lab Solutions</h3>
        </div>
        <div className="clp-header-actions">
          <button className="clp-close" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </div>
      </div>

      <div className="clp-grid">
        {labs.map((l, i) => {
          const isAicte = l.name === "AICTE Idea Lab";
          return (
            <div className="clp-card" key={i} onClick={() => handleCardClick(l, i)}>
              <div className="clp-img-wrap">
                <div className="clp-green-bar" />
                <img src={l.img} alt={l.name} className="clp-img" />
                <div className="clp-badge">{l.icon}</div>
              </div>
              <div className="clp-body">
                <h4 className="clp-name">{l.name}</h4>
                <p className="clp-domain-title">
                  <span className="clp-domain-icon">≡</span> DOMAINS INCLUDES
                </p>
                <div className="clp-tags">
                  {l.domains.map((d, idx) => (
                    <span key={idx} className="clp-tag">{d}</span>
                  ))}
                </div>
                {isAicte ? (
                  <button className="clp-btn clp-btn-enquire">
                    <FaFlask className="clp-btn-left-icon" />
                    <span className="clp-btn-label">ENQUIRE NOW</span>
                    <span className="clp-btn-pill"><FaArrowRight /></span>
                  </button>
                ) : (
                  <button className="clp-btn">
                    <FaLayerGroup className="clp-btn-left-icon" />
                    <span className="clp-btn-label">VIEW PACKAGES</span>
                    <span className="clp-btn-pill"><FaArrowRight /></span>
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {enquiryLab && (
        <EnquiryForm
          labName={enquiryLab.name}
          labImage={enquiryLab.image}
          onClose={() => setEnquiryLab(null)}
        />
      )}
    </div>
  );
}